import React from 'react';

const ExamIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.25,0H2.75A.76.76,0,0,0,2,.75v18.5a.76.76,0,0,0,.75.75h14.5a.76.76,0,0,0,.75-.75V.75A.76.76,0,0,0,17.25,0Zm-.8,18.46H3.55V1.54h12.9Z" />
    <path d="M12,4H8A.75.75,0,0,0,8,5.5h4A.75.75,0,0,0,12,4Z" />
    <path d="M14.8,13.5H10.46a.75.75,0,0,0,0,1.5H14.8a.75.75,0,0,0,0-1.5Z" />
    <path d="M6.92,13.06,5.86,14.18l-.13-.13a.75.75,0,0,0-1.06,1.06l.67.67a.77.77,0,0,0,.54.22.76.76,0,0,0,.53-.23L8,14.1A.75.75,0,0,0,8,13,.75.75,0,0,0,6.92,13.06Z" />
    <path d="M6.92,8.06,5.86,9.18l-.13-.13a.75.75,0,0,0-1.06,1.06l.67.67a.77.77,0,0,0,.54.22.76.76,0,0,0,.53-.23L8,9.1A.75.75,0,0,0,8,8,.75.75,0,0,0,6.92,8.06Z" />
    <path d="M14.8,8.5H10.46a.75.75,0,0,0,0,1.5H14.8a.75.75,0,0,0,0-1.5Z" />
  </svg>
);

export default ExamIcon;
